import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import SimpleInputField from '../SimpleTextField/SimpleTextField';
import * as EmailValidator from 'email-validator';
import { injectIntl } from 'react-intl';

const styles = theme => ({
  root    : {
    flexGrow : 1,
    width    : '100%',
    margin   : 12,
  },
  paper   : {
    padding : 12,
  },
  control : {
    padding : theme.spacing.unit * 2,
  },
  title   : {
    fontSize : 24,
    margin   : 12,
  },
  button  : {
    margin   : theme.spacing.unit,
    fontSize : '24px',
  },
});

const Affiliation = ({ object, action, deleteAction, updateAction, classes, intl }) => (
  <TableRow>
    <TableCell>
      <SimpleInputField
        id="name"
        autoFocus
        required
        label={intl.formatMessage({ id: 'shared.name' })}
        data={object}
        action={action}
        fullWidth
        required
      />
    </TableCell>
    <TableCell>
      <IconButton className={classes.button} aria-label="Delete">
        <DeleteIcon
          onClick={() => {
            deleteAction(object);
          }}
        />
      </IconButton>
    </TableCell>
  </TableRow>
);

const AffiliationWithStyles = withStyles(styles)(Affiliation);
export default injectIntl(AffiliationWithStyles);